import React from 'react'
import { useLocation } from "react-router-dom";

const Navigation = () => {
    
    const location = useLocation()
    //const [active, setActive] = useState(location.hash.split('#')[1])
    
    const id = location.hash.split('#')[1]

    console.log('hash', location.hash);
    console.log('pathname', location.pathname);
    console.log('search', location.search);

    return (
        <div className="app__navigation">
            {['home','about','work','skills','testimonials','contact'].map((i, index)=>(
                <a 
                    href={`#${i}`}
                    key={i + index}
                    style={
                        i === id 
                            ? {backgroundColor:"#313BAC"}
                            : {backgroundColor:"#cbcbcb"}
                    }
                    className="app__navigation-dot"
                >
                    
                </a>

            ))}
        </div>
    )
}

export default Navigation